import { render, staticRenderFns } from "./OnboardingDashboardModelsStep.vue?vue&type=template&id=5eefdcec&scoped=true&"
import script from "./OnboardingDashboardModelsStep.vue?vue&type=script&lang=js&"
export * from "./OnboardingDashboardModelsStep.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingDashboardModelsStep.vue?vue&type=style&index=0&id=5eefdcec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eefdcec",
  null
  
)

export default component.exports